module.exports = __webpack_public_path__ + "img/BurgerKing.c960ee4f.jpeg";